function normalizeBody (value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

function compareBodies (composeBody, graphBody) {
  const compose = normalizeBody(composeBody)
  const graph = normalizeBody(graphBody)
  const commonPrefixLength = getCommonPrefixLength(compose, graph)
  const commonSuffixLength = getCommonSuffixLength(compose, graph, commonPrefixLength)

  if (!compose.length) {
    return {
      consistent: true,
      commonPrefixLength,
      commonSuffixLength
    }
  }

  if (!graph.length) {
    return {
      consistent: false,
      commonPrefixLength,
      commonSuffixLength
    }
  }

  if (compose === graph || graph.includes(compose)) {
    return {
      consistent: true,
      commonPrefixLength,
      commonSuffixLength
    }
  }

  const head = compose.slice(0, Math.min(80, compose.length))
  const tail = compose.slice(-Math.min(120, compose.length))
  return {
    consistent: head.length >= 32 && tail.length >= 32 &&
      graph.includes(head) && graph.includes(tail),
    commonPrefixLength,
    commonSuffixLength
  }
}

function getCommonPrefixLength (left, right) {
  const length = Math.min(left.length, right.length)
  let index = 0

  while (index < length && left[index] === right[index]) {
    index++
  }

  return index
}

function getCommonSuffixLength (left, right, commonPrefixLength) {
  const maxLength = Math.min(left.length, right.length) - commonPrefixLength
  let length = 0

  while (length < maxLength &&
    left[left.length - length - 1] === right[right.length - length - 1]) {
    length++
  }

  return length
}

function normalizeAttachmentNames (names) {
  if (!Array.isArray(names)) {
    return []
  }

  return names
    .map((name) => String(name || '').trim().toLowerCase())
    .filter(Boolean)
    .sort()
}

function attachmentsMatch (composeAttachmentNames, graphAttachmentNames) {
  const compose = normalizeAttachmentNames(composeAttachmentNames)
  const graph = normalizeAttachmentNames(graphAttachmentNames)
  return compose.length === graph.length &&
    compose.every((name, index) => name === graph[index])
}

export function evaluateDraftReadiness ({
  composeBody,
  graphBody,
  graphLastModifiedDateTime,
  composeAttachmentNames,
  graphAttachmentNames,
  previousLastModifiedDateTime,
  stableSince,
  now,
  stableForMs
}) {
  const bodyComparison = compareBodies(composeBody, graphBody)
  const bodyConsistent = bodyComparison.consistent
  const attachmentsConsistent = attachmentsMatch(
    composeAttachmentNames,
    graphAttachmentNames
  )
  const lastModifiedDateTime = String(graphLastModifiedDateTime || '')

  if (bodyConsistent && attachmentsConsistent) {
    return {
      ready: true,
      reason: 'body-match',
      bodyConsistent,
      attachmentsConsistent,
      bodyCommonPrefixLength: bodyComparison.commonPrefixLength,
      bodyCommonSuffixLength: bodyComparison.commonSuffixLength,
      lastModifiedDateTime,
      stableSince
    }
  }

  if (!attachmentsConsistent) {
    return {
      ready: false,
      bodyConsistent,
      attachmentsConsistent,
      bodyCommonPrefixLength: bodyComparison.commonPrefixLength,
      bodyCommonSuffixLength: bodyComparison.commonSuffixLength,
      lastModifiedDateTime,
      stableSince: 0
    }
  }

  const nextStableSince = lastModifiedDateTime === previousLastModifiedDateTime && stableSince
    ? stableSince
    : now

  return {
    ready: now - nextStableSince >= stableForMs,
    reason: 'stable-version',
    bodyConsistent,
    attachmentsConsistent,
    bodyCommonPrefixLength: bodyComparison.commonPrefixLength,
    bodyCommonSuffixLength: bodyComparison.commonSuffixLength,
    lastModifiedDateTime,
    stableSince: nextStableSince
  }
}
